<template>
  <v-dialog
    content-class="dialog-fixed-top"
    :value="isVisible"
    @input="v => v || $dismiss()"
    max-width="600">

    <OLoading :value="isLoading"/>

    <v-card v-if="!isLoading && obj != null">
      <v-toolbar class="card-bar">
        <v-toolbar-title>
          SIM Card: {{obj.iccid}}
        </v-toolbar-title>

        <v-spacer/>

        <v-btn icon @click="mode = 'edit'" v-if="mode == 'view'">
          <v-icon>edit</v-icon>
        </v-btn>

        <v-btn icon @click="mode = 'view'" v-else>
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <DetailsPane :value="obj" v-if="mode == 'view'" />

      <EditPane v-else
        :allOperators="allOperators"
        :value="obj"
        @dismiss="$dismiss()"
        @save="obj => $apply(obj)"/>

    </v-card>

  </v-dialog>
</template>

<script>
import OLoading from 'oderon-vue/cpts/OLoading'
import DetailsPane from './DetailsPane'
import EditPane from './EditPane'
import {SimCard} from '@/models'

export default {
  mixins: [require('oderon-vue/cpts/dialog-promise-mixin').default],
  components: {OLoading, DetailsPane, EditPane},
  props: ['value'],
  data() {
    return {
      isLoading : false,
      obj       : null,
      mode      : 'view',

      allOperators: []
    }
  },
  methods: {
    open(id) {
      this.obj = null
      this.mode = 'view'
      this.$loading(() => this.fetchData(id))
      return this.$open()
    },

    async fetchData(id) {
      let row = await SimCard.findById(id)
      this.obj = row

      this.allOperators = await SimCard.findOperators()
    }
  }
}
</script>
